// ─── Shared Constants ────────────────────────────────────────────────────────

export const API_BASE = '/api/agentHawk';
export const SESSION_NAMES_KEY = 'raven-session-names';
export const ACTIVE_SESSION_KEY_PREFIX = 'raven-active-session';
export const AUTH_RELOAD_KEY = 'raven-auth-reload';

// ─── HistorySidebar Constants ────────────────────────────────────────────────

export const DEFAULT_PAGE_SIZE = 50;
export const DEFAULT_EVENTS_PAGE_SIZE = 50;

/**
 * Regex to strip the AGUI format instruction suffix appended to user messages
 * by the server before sending to AgentCore.
 */
export const AGUI_SUFFIX_REGEX = /\[FORMAT:.*?Return ONLY valid JSON\.\]/s;

/**
 * Regex to strip the <untrusted-input-HASH> wrapper tags injected by Merlin's
 * input sanitization layer. These appear in memory-restored messages.
 */
export const UNTRUSTED_INPUT_REGEX = /<untrusted-input-[a-zA-Z0-9$_]+>\s*([\s\S]*?)\s*<\/untrusted-input-[a-zA-Z0-9$_]+>/;

// ─── RavenChat Constants ─────────────────────────────────────────────────────

export const INSIGHTS_LOOKBACK_MS = 90 * 24 * 60 * 60 * 1000; // 90 days
export const DARK_MODE_KEY = 'darkMode';
export const DARK_MODE_CLASS = 'awsui-polaris-dark-mode';

/** Queries that require a time range picker before execution. */
export const TIME_RANGE_QUERIES = new Set([
  'CW_METRICS',
  'METRICS_AGGREGATIONS_NODES',
  'METRICS_AGGREGATIONS_INDEXES',
  'METRICS_AGGREGATIONS_SHARDS',
  'KEY_EVENTS',
  'DOMAIN_EVENTS',
  'GET_INSIGHTS',
]);

export const THINKING_STAGES: ReadonlyArray<{ icon: string; text: string; at: number }> = [
  { icon: '🔍', text: 'Understanding your question…', at: 0 },
  { icon: '🧠', text: 'Thinking…', at: 3 },
  { icon: '⚡', text: 'Generating response…', at: 8 },
  { icon: '✨', text: 'Almost there…', at: 15 },
  { icon: '⏳', text: 'Still working on it…', at: 25 },
];

/**
 * Curated navigation tabs for the RavenChat top bar.
 * These mirror the DomainDetails tabs relevant to the chat context.
 * Note: DomainDetails tabs are defined inline with content and cannot be imported directly.
 */
export const NAV_TABS = [
  { id: 'agenthawk', label: 'Agent Hawk' },
  { id: 'overview', label: 'Overview' },
  { id: 'logs', label: 'Logs' },
  { id: 'clusterInsights', label: 'Cluster Insights' },
  { id: 'nodeInsights', label: 'Node Insights' },
  { id: 'indexInsights', label: 'Index Insights' },
  { id: 'explorer', label: 'API Explorer' },
] as const;

export const QUICK_OPTIONS = [
  { label: '1h', ms: 1 * 60 * 60 * 1000 },
  { label: '6h', ms: 6 * 60 * 60 * 1000 },
  { label: '1d', ms: 24 * 60 * 60 * 1000 },
  { label: '3d', ms: 3 * 24 * 60 * 60 * 1000 },
  { label: '7d', ms: 7 * 24 * 60 * 60 * 1000 },
  { label: '14d', ms: 14 * 24 * 60 * 60 * 1000 },
];
